export interface NotFeedResponseProps {
  category: string
  description: string
  unit: string
  quantity: number
  unitValue: number
  totalValue: number
}

export const notFeedMock: NotFeedResponseProps[] = [
  {
    category: 'Produto de Limpeza',
    description: 'Álcool',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Produto de Limpeza',
    description: 'Esponja',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Diversos',
    description: 'F4000',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Diversos',
    description: 'Fibra',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Produto de Limpeza',
    description: 'Guardanapo',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Diversos',
    description: 'Lixa',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Produto de Limpeza',
    description: 'Luva Amarela',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Descartável',
    description: 'Luva Descartável',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Produto de Higiene',
    description: 'Palitos',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Produto de Limpeza',
    description: 'Kit de Vassoura e Rodo',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  }
]
